export default {"src":"/_next/static/media/facebook-icon.88608e0c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};